import { render } from "./Fp_ContentsTemplate.vue?vue&type=template&id=0f2f2b53&scoped=true"
const script = {}

import "./Fp_ContentsTemplate.vue?vue&type=style&index=0&id=0f2f2b53&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2f2b53"]])

export default __exports__